<template>
  <div class="servico_bolsas_detalhe" v-if="procedimento != null">
    <div class="row align-center">
      <div class="small-12 medium-12 large-12 columns bolsa_detalhe">
        <StatusBar 
          class="statusbar"
          :estado="procedimento.docbolsa_estado.label"/>
        <div class="row prccontent">
          <div class="small-12 medium-12 large-9 columns">
            <procedimentocontent
             :resumo="procedimento.docbolsa_resumo"
             :edital="procedimento.docbolsa_referencia"
             :area="procedimento.docbolsa_areacientifica"
             :descricao="procedimento.docbolsa_descricao"
             :localtrabalho="procedimento.docbolsa_localtrabalho"
             :duracao="procedimento.docbolsa_duracao" />
          </div>
          <div class="small-12 medium-12 large-3 columns">
            <contenttwo 
              :estado="procedimento.docbolsa_estado.label"
              :unidade="procedimento.docbolsa_unidadeorganica?.post_title"
              :vagas="procedimento.docbolsa_nvagas"
              :datafim="procedimento.docbolsa_datafim"
              :dataatr="procedimento.docbolsa_dataatribuicao" />
          </div>
        </div>
        <Fileslist 
          :files="procedimento.docbolsa_ficheiros"/>
      </div>
    </div>
    <router-link class="button botao_detalhe" to="/bolsas">
      {{ $t("bolsas.vertodosprocedimentos") }}
    </router-link>
  </div>
</template>

<script>
import { onBeforeRouteLeave, useRoute } from 'vue-router';
import { useDetailStore } from '@/stores/detail.js'
import { useBreadcrumbStore } from '@/stores/breadcrumb';
import avtitle from '@/components/avtitle.vue';
import { computed } from "vue";
import axios from '@/axios';
import procedimentocontent from "@/components/bolsa/procedimentocontent.vue";
import contenttwo from "@/components/bolsa/procedimentocontent2.vue";
import Document from '@/components/Document.vue';
import StatusBar from "@/components/bolsa/statusbar.vue";
import Fileslist from '@/components/bolsa/fileslist.vue';
import { i18n } from "@/main.js";

export default {
  components: {
    avtitle,
    procedimentocontent,
    contenttwo,
    Document,
    StatusBar,
    Fileslist
  },
  setup() {

    const store = useDetailStore();
    const procedimento = computed(() => store.currentDetailItem);
    const bstore = useBreadcrumbStore();
    

    const fetchDocuments = (id) => {
      return axios.get(`/bolsa/${id}?idioma=${i18n.global.locale}` )
        .then(resp => {
          const item = resp.data;
          store.setCurrentDetailItem(item);
          bstore.addSection("Bolsas","/bolsas");
          bstore.addSection(item.docbolsa_referencia, "");
        })
        .catch(error => {
          console.log(error);
        })
    }

    if(procedimento.value != undefined){  
      bstore.addSection(procedimento.value.post_title, "");
    }else{
      const route = useRoute();
      fetchDocuments(route.params.id)
    }
   
    onBeforeRouteLeave((to, from, next) => {
      bstore.removeLastSection();
      next()
    })


    return {
      procedimento
    }
  }
}
</script>

<style lang="scss" scoped>
.prccontent > .columns:first-of-type {
  padding-left: 50px;
  padding-right: 40px;
}

@media screen and (max-width:1024px) {

  .prccontent > .columns:first-of-type {
    padding-left: 0;
  }

  .prccontent > .columns{
    padding-right: 25px;
  }

  .prccontent, 
  .servico_bolsas_detalhe, 
  .bolsa_detalhe{
    padding-left: 0;
    padding-right: 0;
  }

  .prccontent{
    margin-left: 42px;
    margin-right: 0;
  }

  .prccontent > .columns {
    padding: 0;
    padding-right: 25px;
  }
}

@media screen and (max-width:767px) {
  .prccontent{
    margin-left: 15px;
  }

  .prccontent > .columns:first-of-type {
    padding-right: 15px;
  }
}


/*#region BoxLayout*/
.servico_bolsas_detalhe>.row {
  border: 1px solid #6eb7ec;
  margin-bottom: 40px;
  margin-top: 60px;
  margin-left: 0px;
  margin-right: 0px;
}

@media (max-width: 767px) {
  .bolsa_detalhe {
    padding-right: 0px;
    padding-left: 0px;
  }
}
/*#endregion*/

.bolsa_detalhe h1 {
  font-family: "Montserrat Bold" !important;
  font-size: 24px !important;
  padding-bottom: 10px !important;
  margin-top: 50px !important;
  color: #535d61 !important;
}

/*#region Button*/
.botao_detalhe {
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  background-color: #6eb7ec;
}

.button.botao_detalhe {
  padding: 20px;
  margin-bottom: 100px;
  margin-left: 35px;
}

@media (max-width: 767px) {

  .servico_bolsas_detalhe{
    margin-left: -15px;
  }

  .button.botao_detalhe {
    margin-left: 0px;
    width: 100%;
    padding: 20px;
    margin-bottom: 100px;
  }

  .servico_bolsas_detalhe>.row {
    margin-top: 18px;
  }

}
/*#endregion*/
</style>